import apis from "../../core/apis.js";

class LogoutResource {
  constructor($resource) {
    "ngInject";

    this.post = (data) => {
      return $resource(apis.logout).save(data);
    };
  }
}

export default LogoutResource;



// WEBPACK FOOTER //
// ./src/resources/logout/logout.resource.js